import React from 'react';
import { LuChevronDown } from 'react-icons/lu';
import { horaTexto } from '../../utils/ordenes';

// Visita de un día que no es hoy, en dos renglones (31-oct-2026). Antes cada visita de la semana salía con la
// tarjeta completa (equipos, chat, instrucciones y "Salir") y entraba una por pantalla. Tocándola se abre la
// tarjeta completa. Si falta confirmar, el "Ok, voy" queda a mano sin abrirla.
export default function VisitaResumen({ orden, color, onAbrir, onConfirmar }) {
    const tentativa = !!orden.sinConfirmar && orden.estado === 'PENDIENTE';
    const pideOk = orden.estado === 'PENDIENTE' && !orden.confirmadaEn && !tentativa && !orden.horarioACoordinar && !!onConfirmar;
    const segunda = [orden.clienteNombre && !String(orden.titulo || '').includes(orden.clienteNombre) ? orden.clienteNombre : null, orden.direccion]
        .filter(Boolean).join(' · ');
    return (
        <div id={`orden-${orden.id}`} role="button" tabIndex={0} onClick={() => onAbrir(orden.id)}
            onKeyDown={(e) => { if (e.key === 'Enter') onAbrir(orden.id); }}
            className="flex items-center gap-3 px-3 py-2.5 rounded-2xl bg-card border border-black/10 dark:border-white/[0.12] active:scale-[0.99] cursor-pointer"
            style={{ borderLeft: `6px solid ${tentativa ? 'var(--warning-tx)' : orden.propia ? '#7C3AED' : color}` }}>
            <div className="w-14 shrink-0 text-center">
                <p className="text-body font-black text-ink leading-tight">{orden.horaEstimada ? horaTexto(orden.horaEstimada) : '—'}</p>
            </div>
            <div className="flex-1 min-w-0">
                <p className="text-body font-black text-ink truncate">{orden.titulo}{orden.propia && <span className="ml-1.5 px-1.5 py-0.5 rounded-md text-[10px] font-black text-[#7C3AED] bg-[rgba(124,58,237,0.15)]">TUYO</span>}</p>
                {segunda && <p className="text-caption text-muted truncate">{segunda}</p>}
            </div>
            {pideOk ? (
                <button type="button" onClick={(e) => { e.stopPropagation(); onConfirmar(orden); }}
                    className="h-9 px-3 shrink-0 rounded-xl text-label font-black text-ink bg-card border-2 border-[color:var(--etapa-listo)] active:scale-95">
                    Ok, voy
                </button>
            ) : (
                <span className="shrink-0 text-label font-black text-secondary">{tentativa ? 'Sin confirmar' : orden.confirmadaEn ? '✓' : ''}</span>
            )}
            <LuChevronDown size={16} className="shrink-0 text-muted" aria-hidden />
        </div>
    );
}
